import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import ButtonWithSVG from "../../Components/layouts/button_with_svg";
import StepRoutes from "../../Routes/steps_routes";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import Pagination from "../../Components/layouts/pagination";
import ClientInvoiceTable from "./Client Invoice/client_invoice_table";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { useSelector } from "react-redux";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcFinePrint } from "react-icons/fc";
import downloadCSV from "../../Components/Functions/download.csv";
import { FaFileInvoice } from "react-icons/fa";

const ClientInvoice = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    businessName: "",
    invoiceType: "",
    project: "",
  });
  const store = useSelector((store) => store.login.user);
  // console.log("Store", store.Role)
  // saleStaff, salesAdmin, salesManager

  const [projects, setProjects] = useState([]);

  const proformaRoles = [
    process.env.REACT_APP_ROLE_SALLE,
    process.env.REACT_APP_ROLE_SALLE_ADMIN,
    process.env.REACT_APP_ROLE_SALES_MANAGER,
  ];

  const isProformaUser = proformaRoles.includes(store?.Role);

  useEffect(() => {
    performRequest("GET", "/clientProject/getCpName/")
      .then((res) => setProjects(res.data.clientProjectsData))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);

    const updatedFilters = {
      ...filters,
      invoiceType: isProformaUser ? "proforma invoice" : filters.invoiceType,
    };

    performRequest(
      "GET",
      getFilteredURL("/invoice/getInvoice/", page, updatedFilters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data.invoiceCount / 50));
        }
      })
      .catch(CustomErrorResponse)
      .finally(() => setLoading(false));
  }, [refresh, page]);

  const handleDownloadCSV = () => {
    performRequest(
      "GET",
      getFilteredURL("/invoice/getInvoiceForCSV/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          if (res.data.invoice.length > 0) {
            let data = res.data.invoice;
            let newData = data?.map((el) => {
              return {
                Name: el.contactPersonName || "---",
                Business_Name: el.businessName || "---",
                Address: el.address || "---",
                GST_Number: el.gstNumber || "---",
                Invoice_Date: el.invoiceDate || "---",
                Invoice_Number:
                  el.manualInvoiceNumber || el.invoiceNumber || "---",
                Invoice_Type: el.invoiceType || "---",
                Place_Of_Supply:
                  el.billingAddress?.state || el.placeOfSupply || "---",
                Sub_Total: el.subTotal ? +el.subTotal : "---",
                SGST:
                  el.billingAddress?.state === "Maharashtra"
                    ? el.totalGst
                      ? +el.totalGst / 2
                      : "---"
                    : "---",
                CGST:
                  el.billingAddress?.state === "Maharashtra"
                    ? el.totalGst
                      ? +el.totalGst / 2
                      : "---"
                    : "---",
                IGST:
                  el.billingAddress?.state !== "Maharashtra"
                    ? el.totalGst
                      ? +el.totalGst
                      : "---"
                    : "---",
                Total_Amount_IncGst: el.totalAmountIncGst
                  ? +el.totalAmountIncGst
                  : "---",
              };
            });
            downloadCSV(newData, "Invoice-Details");
          } else {
            Toast("error", "no data found!");
          }
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FaFileInvoice className="fs-2 me-1" />
                    {isProformaUser
                      ? "Client Proforma Invoice"
                      : "Client Invoice"}
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block">
                    <div className="d-flex">
                      {!isProformaUser && (
                        <button
                          onClick={handleDownloadCSV}
                          className="btn btn-primary w-100 me-2"
                        >
                          Download CSV
                        </button>
                      )}
                      <ButtonWithSVG
                        href={"/client-invoice/new"}
                        buttonText={
                          isProformaUser
                            ? "New Proforma Invoice"
                            : "New Invoice"
                        }
                        svg={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 5l0 14" />
                            <path d="M5 12l14 0" />
                          </svg>
                        }
                      />{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search business name:"
                                  value={filters.businessName}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      businessName: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                />
                              </div>
                              <div className="col-12">
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Invoice Type:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        invoiceType: e.target.value,
                                      })
                                    }
                                    value={filters.invoiceType}
                                  >
                                    <option value="">Select</option>
                                    <option value="invoice">Invoice</option>
                                    <option value="proforma invoice">
                                      Proforma Invoice
                                    </option>
                                    <option value="quotation">Quotation</option>
                                  </DynamicFilterSelect>
                                </div>
                              </div>
                              {(store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                store.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN) && (
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Search project:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        project: e.target.value,
                                      })
                                    }
                                    value={filters.project}
                                  >
                                    <option value="">select all</option>

                                    {projects &&
                                      projects?.map((state, index) => (
                                        <option
                                          key={index}
                                          value={state?.clientName}
                                        >
                                          {state?.clientName}
                                        </option>
                                      ))}
                                  </DynamicFilterSelect>
                                </div>
                              )}

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          businessName: "",
                                          invoiceType: "",
                                          project: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search business name:"
                                value={filters.businessName}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    businessName: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                              />
                            </div>
                            <div className="col-12">
                              <div className="col-12">
                                {!isProformaUser && (
                                  <DynamicFilterSelect
                                    label="Invoice Type:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        invoiceType: e.target.value,
                                      })
                                    }
                                    value={filters.invoiceType}
                                  >
                                    <option value="">Select</option>
                                    <option value="invoice">Invoice</option>
                                    <option value="proforma invoice">
                                      Proforma Invoice
                                    </option>
                                    <option value="quotation">Quotation</option>
                                  </DynamicFilterSelect>
                                )}
                              </div>
                            </div>

                            {(store.Role ===
                              process.env.REACT_APP_ROLE_ADMIN_S ||
                              store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN) && (
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search project:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      project: e.target.value,
                                    })
                                  }
                                  value={filters.project}
                                >
                                  <option value="">select all</option>

                                  {projects &&
                                    projects?.map((state, index) => (
                                      <option
                                        key={index}
                                        value={state?.clientName}
                                      >
                                        {state?.clientName}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div>
                            )}

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        businessName: "",
                                        invoiceType: "",
                                        project: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    {data && data?.invoice && (
                      <ClientInvoiceTable
                        data={data?.invoice}
                        currentPage={page}
                        itemsPerPage={50}
                        isProformaUser={isProformaUser}
                      />
                    )}

                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <div className="d-flex">
                          <button
                            onClick={handleDownloadCSV}
                            className="btn btn-primary w-100 me-2"
                          >
                            Download CSV
                          </button>
                          <ButtonWithSVG
                            href={"/client-invoice/new"}
                            buttonText="New Invoice"
                            svg={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M12 5l0 14" />
                                <path d="M5 12l14 0" />
                              </svg>
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.invoice?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ClientInvoice;
